import {
  AppstoreBadgeDarkIcon,
  GooglePlayBadgeDarkIcon,
} from 'fitify-ui/src/Icon/custom'
import { ArrowDownIcon } from 'fitify-ui/src/Icon/outline'
import AnimatedTextWord from 'fitify-ui-landing/src/components/animations/WordAnimation'
import { Text } from 'fitify-ui-landing/src/components/Text'
import { HeaderImagesPrefetch } from 'fitify-ui-landing/src/components/ui/HeaderImagesPrefetch'
import { AnimatePresence, motion } from 'framer-motion'
import { useTranslation } from 'next-i18next'

import { commonData } from '@/data/common'

import {
  StyledBadgeWrapper,
  StyledHeaderBackground,
  StyledHeaderBackgroundGradient,
  StyledHeaderContainer,
  StyledHeaderDesktop,
  StyledHeaderWrapper,
  StyledHeaderWrapperContent,
  StyledImg,
  StyledScrollDiv,
  StyledScrollLink,
} from './Header.Styled'
import type { HeaderProps } from './Header.Types'
import { useHeader } from './useHeader'

export const DesktopHeader = ({
  headerImages,
  headline,
  subheadline,
}: HeaderProps) => {
  const { t } = useTranslation()
  const {
    currentImage,
    currentImageIndex,
    handleScrollToAnimation,
    isImageSliderMounted,
  } = useHeader({ headerImages })

  return (
    <>
      <HeaderImagesPrefetch images={headerImages} />

      <StyledHeaderDesktop>
        <StyledHeaderBackgroundGradient />
        <StyledHeaderContainer>
          <StyledHeaderWrapper>
            <StyledHeaderWrapperContent>
              <AnimatedTextWord text={t(headline)} />

              <Text
                as="p"
                color="White"
                variant="header-paragraph"
                style={{ maxWidth: '496px' }}
              >
                {t(subheadline)}
              </Text>

              <StyledBadgeWrapper>
                <a href={commonData.store.appStore} rel="noreferrer">
                  <AppstoreBadgeDarkIcon />
                </a>
                <a href={commonData.store.playStore} rel="noreferrer">
                  <GooglePlayBadgeDarkIcon />
                </a>
              </StyledBadgeWrapper>
            </StyledHeaderWrapperContent>
          </StyledHeaderWrapper>

          <StyledScrollDiv>
            <StyledScrollLink
              onClick={handleScrollToAnimation}
              aria-label={t('cl_aria_label_scroll_down')}
            >
              <ArrowDownIcon color={'White'} />
            </StyledScrollLink>
          </StyledScrollDiv>
        </StyledHeaderContainer>
        <StyledHeaderBackground>
          <AnimatePresence>
            <StyledImg
              as={motion.img}
              key={'headerImage_' + currentImageIndex}
              initial={isImageSliderMounted ? { opacity: 0 } : {}}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              transition={{ duration: 1 }}
              style={{
                position: 'absolute',
                minHeight: '100vh',
              }}
              src={currentImage.headerImage}
              srcSet={currentImage.headerImageSet}
              alt={`Header Image - ${currentImageIndex}}`}
            />
          </AnimatePresence>
        </StyledHeaderBackground>
      </StyledHeaderDesktop>
    </>
  )
}
